import Notification from "../notification/notification";

export default new class ByOneArticle {
  constructor() {
    this.sByOneArticleClass = 'by-one-article';

    this.init();
  }

  init() {
    this.handler();
  }

  handler() {
    $(document).on('click', `.${this.sByOneArticleClass}`, (obEvent) => {
      const _this = this;
      const obButton = $(obEvent.target);
      const iOfferID = obButton.attr('data-offer-id');
      const iArticleID = obButton.attr('data-article-id');
      const iPaymentMethodID = obButton.attr('data-payment-method-id');
      const sType = obButton.attr('data-type') ? obButton.attr('data-type') : 'calc';
      _this.obRequestOnAdd = {
        cart: [
          {
            offer_id: iOfferID,
            quantity: 1,
            property: {access_element_id: iArticleID, access_element_type: 'Lovata\\GoodNews\\Models\\Article'}
          },
        ],
      };
      _this.obRequestOnCreate = {
        order: {
          type: sType,
          payment_method_id: iPaymentMethodID,
        },
      };

      // Clear cart
      // Add cart position
      $.request('Cart::onSync', {
        data: _this.obRequestOnAdd,
        success(obResponseOnAdd) {
          if (!obResponseOnAdd.X_OCTOBER_REDIRECT && !obResponseOnAdd.status) {
            Notification.showError(obResponseOnAdd && obResponseOnAdd.message);
          }
          // Create order
          $.request('MakeOrder::onCreate', {
            data: _this.obRequestOnCreate,
            success(obResponseonCreate) {
              if (!obResponseonCreate.X_OCTOBER_REDIRECT && !obResponseonCreate.status) {
                Notification.showError(obResponseonCreate && obResponseonCreate.message);
              }
              this.success(obResponseonCreate);

              if (redirect) {
                location.href = redirect;
              }
            },
          });
        }
      });
    });
  }
}();
